import create from "zustand";

import {
  getLocalStorageValue,
  setLocalStorageValue,
} from "../modules/common/utils/localStorage.utils";

export const uiStore = create((set) => ({
  settings: null,

  lists: {
    isProcessing: false,
    carriers: null,
    countries: null,
  },

  newsCounter: null,

  getSettings(user) {
    const localStorageKey = `sn_UI_${user.id}`;
    const storedData = getLocalStorageValue(localStorageKey);
    let parsedSettings = null;

    if (storedData) {
      try {
        parsedSettings = JSON.parse(storedData);
      } catch (error) {
        console.error("Error parsing settings from localStorage:", error);
      }
    }

    return (
      parsedSettings || {
        exchanges: { showArchived: false },
      }
    );
  },

  setSettings: (newSettings, user) => {
    set((state) => {
      const updatedSettings = {
        ...state.settings,
        ...Object.keys(newSettings).reduce(
          (acc, key) => ({
            ...acc,
            [key]: {
              ...state.settings[key],
              ...newSettings[key],
            },
          }),
          {}
        ),
      };

      const localStorageKey = `sn_UI_${user.id}`;
      setLocalStorageValue(localStorageKey, JSON.stringify(updatedSettings));

      return { settings: updatedSettings };
    });
  },

  setNewsCounter(counter) {
    set((state) => {
      if (counter === state.newsCounter) return state;
      return { newsCounter: counter };
    });
  },

  afterSignIn: async (data) => {
    const { user, ...listData } = data;
    //? get localstorage
    const localSettings = uiStore.getState().getSettings(user);

    set((state) => ({
      lists: {
        ...state.lists,
        ...listData,
      },
      settings: {
        ...state.settings,
        ...localSettings,
      },
    }));
  },
}));
